import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { BoxForm, RadioGroup } from 'components/Form'
import { EndAbTestContext } from '../context/EndAbTestContext'
import { useGetVariantOptions } from './hooks/useGetVariantOptions'
import { Schema } from './schema'

export const Form = (): React.JSX.Element => {
  const { t } = useTranslation('features/abTests', { keyPrefix: 'endTest.form' })
  const {
    abTest: {
      domain: { name: domainName },
      usedVariantsData,
    },
  } = useContext(EndAbTestContext)
  const { control } = useFormContext<Schema>()
  const { variantOptions } = useGetVariantOptions({ usedVariantsData })

  return (
    <BoxForm>
      <RadioGroup
        control={control}
        label={t('variant.label', { domainName })}
        name='variantName'
        options={variantOptions}
      />
    </BoxForm>
  )
}
